import React from 'react'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import ptBR from 'dayjs/locale/pt-br'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import SmallTextField from '../textfield/SmallTextfield'
import { any, func, object, bool } from 'prop-types'
import { InputAdornment, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'
const BaseDatePicker = ({
  value,
  onChange,
  clearable = true,
  onClear = () => {},
  inputProps,
  ...props
}) => {
  return (
    <LocalizationProvider
      adapterLocale={ptBR}
      style={{ backgroundColor: 'red' }}
      dateAdapter={AdapterDayjs}
    >
      <DatePicker
        value={value}
        onChange={date => {
          if (date !== null)
            if (!isNaN(date?.$D)) {
              onChange(date)
            }
        }}
        renderInput={params => {
          return (
            <SmallTextField
              {...params}
              {...inputProps}
              InputProps={{
                endAdornment: (
                  <>
                    {params.InputProps.endAdornment}
                    {clearable && (
                      <InputAdornment position="end">
                        <IconButton
                          sx={{ marginBottom: '3px' }}
                          onClick={() => {
                            onClear()
                          }}
                        >
                          <Close />
                        </IconButton>
                      </InputAdornment>
                    )}
                  </>
                )
              }}
            />
          )
        }}
        {...props}
      />
    </LocalizationProvider>
  )
}
BaseDatePicker.propTypes = {
  value: any,
  onChange: func,
  onClear: func,
  inputProps: object,
  clearable: bool
}
export default BaseDatePicker
